// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../../shared/src/Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Apollo = require("../../../shared/src/bindings/Apollo.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var CommonTypes_Email = require("../../../shared/src/types/CommonTypes_Email.bs.js");
var CommonTypes_User_Name = require("../../../shared/src/types/CommonTypes_User_Name.bs.js");
var WebTypes_BusinessAdmin = require("../types/WebTypes_BusinessAdmin.bs.js");
var CommonTypes_PhoneNumber = require("../../../shared/src/types/CommonTypes_PhoneNumber.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var CommonTypes_Business_Manager = require("../../../shared/src/types/business/CommonTypes_Business_Manager.bs.js");
var CommonTypes_Business_Location = require("../../../shared/src/types/business/CommonTypes_Business_Location.bs.js");

var Raw = {};

var query = "query   {\ncurrentUser  {\nid  \nbusiness  {\nid  \nadmins  {\nnodes  {\n...WebTypes_BusinessAdmin   \n}\n\n}\n\n}\n\n}\n\n}\n" + WebTypes_BusinessAdmin.query;

function parse(value) {
  var value$1 = value.currentUser;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.business;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.admins;
      var value$4 = value$3.nodes;
      tmp$1 = {
        id: value$2.id,
        admins: {
          nodes: value$4.map(function (value) {
                if (!(value == null)) {
                  return WebTypes_BusinessAdmin.verifyArgsAndParse("WebTypes_BusinessAdmin", value);
                }
                
              })
        }
      };
    }
    tmp = {
      id: value$1.id,
      business: tmp$1
    };
  }
  return {
          currentUser: tmp
        };
}

function serialize(value) {
  var value$1 = value.currentUser;
  var currentUser;
  if (value$1 !== undefined) {
    var value$2 = value$1.business;
    var business;
    if (value$2 !== undefined) {
      var value$3 = value$2.admins;
      var value$4 = value$3.nodes;
      var nodes = value$4.map(function (value) {
            if (value !== undefined) {
              return WebTypes_BusinessAdmin.serialize(value);
            } else {
              return null;
            }
          });
      var admins = {
        nodes: nodes
      };
      var value$5 = value$2.id;
      business = {
        id: value$5,
        admins: admins
      };
    } else {
      business = null;
    }
    var value$6 = value$1.id;
    currentUser = {
      id: value$6,
      business: business
    };
  } else {
    currentUser = null;
  }
  return {
          currentUser: currentUser
        };
}

function serializeVariables(param) {
  
}

function makeVariables(param) {
  
}

function makeDefaultVariables(param) {
  
}

function variables(param) {
  return Json.Encode.object_(/* [] */0);
}

function decode(param) {
  var match = param.currentUser;
  if (match === undefined) {
    return ;
  }
  var match$1 = match.business;
  if (match$1 !== undefined) {
    return Relude_Option.pure(Curry._1(WebTypes_BusinessAdmin.$$Set.fromArray, Relude_Array.mapOption(Curry._1(Relude_Option.flatMap, WebTypes_BusinessAdmin.tToR), match$1.admins.nodes)));
  }
  
}

var Definition = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  variables: variables,
  decode: decode
};

var include = Apollo.CreateQuery({
      Raw: Raw,
      query: query,
      variables: variables,
      parse: parse,
      decode: decode
    });

var GetBusinessAdmins_graphqlQueryAST = include.graphqlQueryAST;

var GetBusinessAdmins_query = include.query;

var GetBusinessAdmins_queryStoreError = include.queryStoreError;

var GetBusinessAdmins_queryResult = include.queryResult;

var GetBusinessAdmins_queryAsyncData = include.queryAsyncData;

var GetBusinessAdmins_queryAsyncDataStoreError = include.queryAsyncDataStoreError;

var GetBusinessAdmins_queryAsyncResult = include.queryAsyncResult;

var GetBusinessAdmins = {
  Definition: Definition,
  graphqlQueryAST: GetBusinessAdmins_graphqlQueryAST,
  query: GetBusinessAdmins_query,
  queryStoreError: GetBusinessAdmins_queryStoreError,
  queryResult: GetBusinessAdmins_queryResult,
  queryAsyncData: GetBusinessAdmins_queryAsyncData,
  queryAsyncDataStoreError: GetBusinessAdmins_queryAsyncDataStoreError,
  queryAsyncResult: GetBusinessAdmins_queryAsyncResult
};

var Raw$1 = {};

var query$1 = "mutation AddBusinessAdmin($firstName: String!, $lastName: String!, $phoneNumber: PhoneNumber!, $email: Email!)  {\naddBusinessAdmin(input: {firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, email: $email})  {\nuser  {\n...WebTypes_BusinessAdmin   \n}\n\n}\n\n}\n" + WebTypes_BusinessAdmin.query;

function parse$1(value) {
  var value$1 = value.addBusinessAdmin;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.user;
    tmp = {
      user: !(value$2 == null) ? WebTypes_BusinessAdmin.verifyArgsAndParse("WebTypes_BusinessAdmin", value$2) : undefined
    };
  }
  return {
          addBusinessAdmin: tmp
        };
}

function serialize$1(value) {
  var value$1 = value.addBusinessAdmin;
  var addBusinessAdmin;
  if (value$1 !== undefined) {
    var value$2 = value$1.user;
    var user = value$2 !== undefined ? WebTypes_BusinessAdmin.serialize(value$2) : null;
    addBusinessAdmin = {
      user: user
    };
  } else {
    addBusinessAdmin = null;
  }
  return {
          addBusinessAdmin: addBusinessAdmin
        };
}

function serializeVariables$1(inp) {
  return {
          firstName: inp.firstName,
          lastName: inp.lastName,
          phoneNumber: inp.phoneNumber,
          email: inp.email
        };
}

function makeVariables$1(firstName, lastName, phoneNumber, email, param) {
  return {
          firstName: firstName,
          lastName: lastName,
          phoneNumber: phoneNumber,
          email: email
        };
}

function variables$1(param) {
  return Json.Encode.object_({
              hd: [
                "firstName",
                Curry._1(CommonTypes_User_Name.FirstName.encode, param.firstName)
              ],
              tl: {
                hd: [
                  "lastName",
                  Curry._1(CommonTypes_User_Name.LastName.encode, param.lastName)
                ],
                tl: {
                  hd: [
                    "email",
                    Curry._1(CommonTypes_Email.encode, param.email)
                  ],
                  tl: {
                    hd: [
                      "phoneNumber",
                      CommonTypes_PhoneNumber.encode(param.phoneNumber)
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

function decode$1(param) {
  var match = param.addBusinessAdmin;
  if (match !== undefined) {
    return Curry._2(Relude_Option.flatMap, WebTypes_BusinessAdmin.tToR, match.user);
  }
  
}

var Definition$1 = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  variables: variables$1,
  decode: decode$1
};

var include$1 = Apollo.CreateMutation({
      Raw: Raw$1,
      query: query$1,
      variables: variables$1,
      parse: parse$1,
      decode: decode$1
    });

var AddBusinessAdmin_graphqlMutationAST = include$1.graphqlMutationAST;

var AddBusinessAdmin_mutate = include$1.mutate;

var AddBusinessAdmin_mutateStoreError = include$1.mutateStoreError;

var AddBusinessAdmin_mutateResult = include$1.mutateResult;

var AddBusinessAdmin_mutateResultStore = include$1.mutateResultStore;

var AddBusinessAdmin_mutateAsyncData = include$1.mutateAsyncData;

var AddBusinessAdmin_mutateAsyncResult = include$1.mutateAsyncResult;

var AddBusinessAdmin_mutateAsycResultApolloError = include$1.mutateAsycResultApolloError;

var AddBusinessAdmin = {
  Definition: Definition$1,
  graphqlMutationAST: AddBusinessAdmin_graphqlMutationAST,
  mutate: AddBusinessAdmin_mutate,
  mutateStoreError: AddBusinessAdmin_mutateStoreError,
  mutateResult: AddBusinessAdmin_mutateResult,
  mutateResultStore: AddBusinessAdmin_mutateResultStore,
  mutateAsyncData: AddBusinessAdmin_mutateAsyncData,
  mutateAsyncResult: AddBusinessAdmin_mutateAsyncResult,
  mutateAsycResultApolloError: AddBusinessAdmin_mutateAsycResultApolloError
};

var Raw$2 = {};

var query$2 = "mutation UpdateBusinessAdmin($id: BigInt!, $firstName: String!, $lastName: String!, $email: Email, $phoneNumber: PhoneNumber!)  {\nupdateBusinessAdmin(input: {userIdToUpdate: $id, firstName: $firstName, lastName: $lastName, email: $email, phoneNumber: $phoneNumber})  {\nuser  {\n...WebTypes_BusinessAdmin   \n}\n\n}\n\n}\n" + WebTypes_BusinessAdmin.query;

function parse$2(value) {
  var value$1 = value.updateBusinessAdmin;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.user;
    tmp = {
      user: !(value$2 == null) ? WebTypes_BusinessAdmin.verifyArgsAndParse("WebTypes_BusinessAdmin", value$2) : undefined
    };
  }
  return {
          updateBusinessAdmin: tmp
        };
}

function serialize$2(value) {
  var value$1 = value.updateBusinessAdmin;
  var updateBusinessAdmin;
  if (value$1 !== undefined) {
    var value$2 = value$1.user;
    var user = value$2 !== undefined ? WebTypes_BusinessAdmin.serialize(value$2) : null;
    updateBusinessAdmin = {
      user: user
    };
  } else {
    updateBusinessAdmin = null;
  }
  return {
          updateBusinessAdmin: updateBusinessAdmin
        };
}

function serializeVariables$2(inp) {
  var a = inp.email;
  return {
          id: inp.id,
          firstName: inp.firstName,
          lastName: inp.lastName,
          email: a !== undefined ? Caml_option.valFromOption(a) : undefined,
          phoneNumber: inp.phoneNumber
        };
}

function makeVariables$2(id, firstName, lastName, email, phoneNumber, param) {
  return {
          id: id,
          firstName: firstName,
          lastName: lastName,
          email: email,
          phoneNumber: phoneNumber
        };
}

function variables$2(param) {
  var match = param.name;
  return Json.Encode.object_({
              hd: [
                "id",
                Curry._1(WebTypes_BusinessAdmin.Id.encode, param.id)
              ],
              tl: {
                hd: [
                  "firstName",
                  Curry._1(CommonTypes_User_Name.FirstName.encode, match.firstName)
                ],
                tl: {
                  hd: [
                    "lastName",
                    Curry._1(CommonTypes_User_Name.LastName.encode, match.lastName)
                  ],
                  tl: {
                    hd: [
                      "email",
                      Curry._1(CommonTypes_Email.encode, param.email)
                    ],
                    tl: {
                      hd: [
                        "phoneNumber",
                        CommonTypes_PhoneNumber.encode(param.phoneNumber)
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

function decode$2(param) {
  var match = param.updateBusinessAdmin;
  if (match !== undefined) {
    return Curry._2(Relude_Option.flatMap, WebTypes_BusinessAdmin.tToR, match.user);
  }
  
}

var Definition$2 = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  variables: variables$2,
  decode: decode$2
};

var include$2 = Apollo.CreateMutation({
      Raw: Raw$2,
      query: query$2,
      variables: variables$2,
      parse: parse$2,
      decode: decode$2
    });

var EditBusinessAdmin_graphqlMutationAST = include$2.graphqlMutationAST;

var EditBusinessAdmin_mutate = include$2.mutate;

var EditBusinessAdmin_mutateStoreError = include$2.mutateStoreError;

var EditBusinessAdmin_mutateResult = include$2.mutateResult;

var EditBusinessAdmin_mutateResultStore = include$2.mutateResultStore;

var EditBusinessAdmin_mutateAsyncData = include$2.mutateAsyncData;

var EditBusinessAdmin_mutateAsyncResult = include$2.mutateAsyncResult;

var EditBusinessAdmin_mutateAsycResultApolloError = include$2.mutateAsycResultApolloError;

var EditBusinessAdmin = {
  Definition: Definition$2,
  graphqlMutationAST: EditBusinessAdmin_graphqlMutationAST,
  mutate: EditBusinessAdmin_mutate,
  mutateStoreError: EditBusinessAdmin_mutateStoreError,
  mutateResult: EditBusinessAdmin_mutateResult,
  mutateResultStore: EditBusinessAdmin_mutateResultStore,
  mutateAsyncData: EditBusinessAdmin_mutateAsyncData,
  mutateAsyncResult: EditBusinessAdmin_mutateAsyncResult,
  mutateAsycResultApolloError: EditBusinessAdmin_mutateAsycResultApolloError
};

var Raw$3 = {};

var query$3 = "mutation RemoveBusinessAdmin($userId: BigInt!)  {\nremoveBusinessAdmin(input: {userIdToRemove: $userId})  {\nuser  {\n...WebTypes_BusinessAdmin   \n}\n\n}\n\n}\n" + WebTypes_BusinessAdmin.query;

function parse$3(value) {
  var value$1 = value.removeBusinessAdmin;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.user;
    tmp = {
      user: !(value$2 == null) ? WebTypes_BusinessAdmin.verifyArgsAndParse("WebTypes_BusinessAdmin", value$2) : undefined
    };
  }
  return {
          removeBusinessAdmin: tmp
        };
}

function serialize$3(value) {
  var value$1 = value.removeBusinessAdmin;
  var removeBusinessAdmin;
  if (value$1 !== undefined) {
    var value$2 = value$1.user;
    var user = value$2 !== undefined ? WebTypes_BusinessAdmin.serialize(value$2) : null;
    removeBusinessAdmin = {
      user: user
    };
  } else {
    removeBusinessAdmin = null;
  }
  return {
          removeBusinessAdmin: removeBusinessAdmin
        };
}

function serializeVariables$3(inp) {
  return {
          userId: inp.userId
        };
}

function makeVariables$3(userId, param) {
  return {
          userId: userId
        };
}

function variables$3(id) {
  return Json.Encode.object_({
              hd: [
                "userId",
                Curry._1(WebTypes_BusinessAdmin.Id.encode, id)
              ],
              tl: /* [] */0
            });
}

function decode$3(param) {
  var match = param.removeBusinessAdmin;
  if (match !== undefined) {
    return Curry._2(Relude_Option.flatMap, WebTypes_BusinessAdmin.tToR, match.user);
  }
  
}

var Definition$3 = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  variables: variables$3,
  decode: decode$3
};

var include$3 = Apollo.CreateMutation({
      Raw: Raw$3,
      query: query$3,
      variables: variables$3,
      parse: parse$3,
      decode: decode$3
    });

var RemoveBusinessAdmin_graphqlMutationAST = include$3.graphqlMutationAST;

var RemoveBusinessAdmin_mutate = include$3.mutate;

var RemoveBusinessAdmin_mutateStoreError = include$3.mutateStoreError;

var RemoveBusinessAdmin_mutateResult = include$3.mutateResult;

var RemoveBusinessAdmin_mutateResultStore = include$3.mutateResultStore;

var RemoveBusinessAdmin_mutateAsyncData = include$3.mutateAsyncData;

var RemoveBusinessAdmin_mutateAsyncResult = include$3.mutateAsyncResult;

var RemoveBusinessAdmin_mutateAsycResultApolloError = include$3.mutateAsycResultApolloError;

var RemoveBusinessAdmin = {
  Definition: Definition$3,
  graphqlMutationAST: RemoveBusinessAdmin_graphqlMutationAST,
  mutate: RemoveBusinessAdmin_mutate,
  mutateStoreError: RemoveBusinessAdmin_mutateStoreError,
  mutateResult: RemoveBusinessAdmin_mutateResult,
  mutateResultStore: RemoveBusinessAdmin_mutateResultStore,
  mutateAsyncData: RemoveBusinessAdmin_mutateAsyncData,
  mutateAsyncResult: RemoveBusinessAdmin_mutateAsyncResult,
  mutateAsycResultApolloError: RemoveBusinessAdmin_mutateAsycResultApolloError
};

var Raw$4 = {};

var query$4 = "query   {\ncurrentUser  {\nid  \nbusiness  {\nid  \nmanagers  {\nnodes  {\n...CommonTypes_Business_Manager   \n}\n\n}\n\n}\n\nmanagedBusiness  {\nid  \nmanagers  {\nnodes  {\n...CommonTypes_Business_Manager   \n}\n\n}\n\n}\n\n}\n\n}\n" + CommonTypes_Business_Manager.query;

function parse$4(value) {
  var value$1 = value.currentUser;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.business;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.managers;
      var value$4 = value$3.nodes;
      tmp$1 = {
        id: value$2.id,
        managers: {
          nodes: value$4.map(function (value) {
                if (!(value == null)) {
                  return CommonTypes_Business_Manager.verifyArgsAndParse("CommonTypes_Business_Manager", value);
                }
                
              })
        }
      };
    }
    var value$5 = value$1.managedBusiness;
    var tmp$2;
    if (value$5 == null) {
      tmp$2 = undefined;
    } else {
      var value$6 = value$5.managers;
      var value$7 = value$6.nodes;
      tmp$2 = {
        id: value$5.id,
        managers: {
          nodes: value$7.map(function (value) {
                if (!(value == null)) {
                  return CommonTypes_Business_Manager.verifyArgsAndParse("CommonTypes_Business_Manager", value);
                }
                
              })
        }
      };
    }
    tmp = {
      id: value$1.id,
      business: tmp$1,
      managedBusiness: tmp$2
    };
  }
  return {
          currentUser: tmp
        };
}

function serialize$4(value) {
  var value$1 = value.currentUser;
  var currentUser;
  if (value$1 !== undefined) {
    var value$2 = value$1.managedBusiness;
    var managedBusiness;
    if (value$2 !== undefined) {
      var value$3 = value$2.managers;
      var value$4 = value$3.nodes;
      var nodes = value$4.map(function (value) {
            if (value !== undefined) {
              return CommonTypes_Business_Manager.serialize(value);
            } else {
              return null;
            }
          });
      var managers = {
        nodes: nodes
      };
      var value$5 = value$2.id;
      managedBusiness = {
        id: value$5,
        managers: managers
      };
    } else {
      managedBusiness = null;
    }
    var value$6 = value$1.business;
    var business;
    if (value$6 !== undefined) {
      var value$7 = value$6.managers;
      var value$8 = value$7.nodes;
      var nodes$1 = value$8.map(function (value) {
            if (value !== undefined) {
              return CommonTypes_Business_Manager.serialize(value);
            } else {
              return null;
            }
          });
      var managers$1 = {
        nodes: nodes$1
      };
      var value$9 = value$6.id;
      business = {
        id: value$9,
        managers: managers$1
      };
    } else {
      business = null;
    }
    var value$10 = value$1.id;
    currentUser = {
      id: value$10,
      business: business,
      managedBusiness: managedBusiness
    };
  } else {
    currentUser = null;
  }
  return {
          currentUser: currentUser
        };
}

function serializeVariables$4(param) {
  
}

function makeVariables$4(param) {
  
}

function makeDefaultVariables$1(param) {
  
}

function variables$4(param) {
  return Json.Encode.object_(/* [] */0);
}

function decode$4(param) {
  var nodes;
  var match = param.currentUser;
  if (match === undefined) {
    return ;
  }
  var match$1 = match.business;
  if (match$1 !== undefined) {
    nodes = match$1.managers.nodes;
  } else {
    var match$2 = match.managedBusiness;
    if (match$2 === undefined) {
      return ;
    }
    nodes = match$2.managers.nodes;
  }
  return Relude_Option.pure(Curry._1(CommonTypes_Business_Manager.$$Set.fromArray, Relude_Array.mapOption(Curry._1(Relude_Option.flatMap, CommonTypes_Business_Manager.tToR), nodes)));
}

var Definition$4 = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  makeDefaultVariables: makeDefaultVariables$1,
  variables: variables$4,
  decode: decode$4
};

var include$4 = Apollo.CreateQuery({
      Raw: Raw$4,
      query: query$4,
      variables: variables$4,
      parse: parse$4,
      decode: decode$4
    });

var GetBusinessManagers_graphqlQueryAST = include$4.graphqlQueryAST;

var GetBusinessManagers_query = include$4.query;

var GetBusinessManagers_queryStoreError = include$4.queryStoreError;

var GetBusinessManagers_queryResult = include$4.queryResult;

var GetBusinessManagers_queryAsyncData = include$4.queryAsyncData;

var GetBusinessManagers_queryAsyncDataStoreError = include$4.queryAsyncDataStoreError;

var GetBusinessManagers_queryAsyncResult = include$4.queryAsyncResult;

var GetBusinessManagers = {
  Definition: Definition$4,
  graphqlQueryAST: GetBusinessManagers_graphqlQueryAST,
  query: GetBusinessManagers_query,
  queryStoreError: GetBusinessManagers_queryStoreError,
  queryResult: GetBusinessManagers_queryResult,
  queryAsyncData: GetBusinessManagers_queryAsyncData,
  queryAsyncDataStoreError: GetBusinessManagers_queryAsyncDataStoreError,
  queryAsyncResult: GetBusinessManagers_queryAsyncResult
};

var Raw$5 = {};

var query$5 = "mutation AddBusinessManager($firstName: String!, $lastName: String!, $phoneNumber: PhoneNumber!)  {\naddBusinessManager(input: {firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber})  {\nuser  {\n...CommonTypes_Business_Manager   \n}\n\n}\n\n}\n" + CommonTypes_Business_Manager.query;

function parse$5(value) {
  var value$1 = value.addBusinessManager;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.user;
    tmp = {
      user: !(value$2 == null) ? CommonTypes_Business_Manager.verifyArgsAndParse("CommonTypes_Business_Manager", value$2) : undefined
    };
  }
  return {
          addBusinessManager: tmp
        };
}

function serialize$5(value) {
  var value$1 = value.addBusinessManager;
  var addBusinessManager;
  if (value$1 !== undefined) {
    var value$2 = value$1.user;
    var user = value$2 !== undefined ? CommonTypes_Business_Manager.serialize(value$2) : null;
    addBusinessManager = {
      user: user
    };
  } else {
    addBusinessManager = null;
  }
  return {
          addBusinessManager: addBusinessManager
        };
}

function serializeVariables$5(inp) {
  return {
          firstName: inp.firstName,
          lastName: inp.lastName,
          phoneNumber: inp.phoneNumber
        };
}

function makeVariables$5(firstName, lastName, phoneNumber, param) {
  return {
          firstName: firstName,
          lastName: lastName,
          phoneNumber: phoneNumber
        };
}

function variables$5(param) {
  return Json.Encode.object_({
              hd: [
                "firstName",
                Curry._1(CommonTypes_User_Name.FirstName.encode, param.firstName)
              ],
              tl: {
                hd: [
                  "lastName",
                  Curry._1(CommonTypes_User_Name.LastName.encode, param.lastName)
                ],
                tl: {
                  hd: [
                    "phoneNumber",
                    CommonTypes_LongPhoneNumber.encode(param.phoneNumber)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function decode$5(param) {
  var match = param.addBusinessManager;
  if (match !== undefined) {
    return Curry._2(Relude_Option.flatMap, CommonTypes_Business_Manager.tToR, match.user);
  }
  
}

var Definition$5 = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$5,
  makeVariables: makeVariables$5,
  variables: variables$5,
  decode: decode$5
};

var include$5 = Apollo.CreateMutation({
      Raw: Raw$5,
      query: query$5,
      variables: variables$5,
      parse: parse$5,
      decode: decode$5
    });

var AddBusinessManager_graphqlMutationAST = include$5.graphqlMutationAST;

var AddBusinessManager_mutate = include$5.mutate;

var AddBusinessManager_mutateStoreError = include$5.mutateStoreError;

var AddBusinessManager_mutateResult = include$5.mutateResult;

var AddBusinessManager_mutateResultStore = include$5.mutateResultStore;

var AddBusinessManager_mutateAsyncData = include$5.mutateAsyncData;

var AddBusinessManager_mutateAsyncResult = include$5.mutateAsyncResult;

var AddBusinessManager_mutateAsycResultApolloError = include$5.mutateAsycResultApolloError;

var AddBusinessManager = {
  Definition: Definition$5,
  graphqlMutationAST: AddBusinessManager_graphqlMutationAST,
  mutate: AddBusinessManager_mutate,
  mutateStoreError: AddBusinessManager_mutateStoreError,
  mutateResult: AddBusinessManager_mutateResult,
  mutateResultStore: AddBusinessManager_mutateResultStore,
  mutateAsyncData: AddBusinessManager_mutateAsyncData,
  mutateAsyncResult: AddBusinessManager_mutateAsyncResult,
  mutateAsycResultApolloError: AddBusinessManager_mutateAsycResultApolloError
};

var Raw$6 = {};

var query$6 = "mutation UpdateBusinessManager($id: BigInt!, $firstName: String!, $lastName: String!, $phoneNumber: PhoneNumber!)  {\nupdateBusinessManager(input: {userIdToUpdate: $id, firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber})  {\nuser  {\n...CommonTypes_Business_Manager   \n}\n\n}\n\n}\n" + CommonTypes_Business_Manager.query;

function parse$6(value) {
  var value$1 = value.updateBusinessManager;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.user;
    tmp = {
      user: !(value$2 == null) ? CommonTypes_Business_Manager.verifyArgsAndParse("CommonTypes_Business_Manager", value$2) : undefined
    };
  }
  return {
          updateBusinessManager: tmp
        };
}

function serialize$6(value) {
  var value$1 = value.updateBusinessManager;
  var updateBusinessManager;
  if (value$1 !== undefined) {
    var value$2 = value$1.user;
    var user = value$2 !== undefined ? CommonTypes_Business_Manager.serialize(value$2) : null;
    updateBusinessManager = {
      user: user
    };
  } else {
    updateBusinessManager = null;
  }
  return {
          updateBusinessManager: updateBusinessManager
        };
}

function serializeVariables$6(inp) {
  return {
          id: inp.id,
          firstName: inp.firstName,
          lastName: inp.lastName,
          phoneNumber: inp.phoneNumber
        };
}

function makeVariables$6(id, firstName, lastName, phoneNumber, param) {
  return {
          id: id,
          firstName: firstName,
          lastName: lastName,
          phoneNumber: phoneNumber
        };
}

function variables$6(param) {
  var match = param.name;
  return Json.Encode.object_({
              hd: [
                "id",
                Curry._1(CommonTypes_Business_Manager.Id.encode, param.id)
              ],
              tl: {
                hd: [
                  "firstName",
                  Curry._1(CommonTypes_User_Name.FirstName.encode, match.firstName)
                ],
                tl: {
                  hd: [
                    "lastName",
                    Curry._1(CommonTypes_User_Name.LastName.encode, match.lastName)
                  ],
                  tl: {
                    hd: [
                      "phoneNumber",
                      CommonTypes_LongPhoneNumber.encode(param.phoneNumber)
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

function decode$6(param) {
  var match = param.updateBusinessManager;
  if (match !== undefined) {
    return Curry._2(Relude_Option.flatMap, CommonTypes_Business_Manager.tToR, match.user);
  }
  
}

var Definition$6 = {
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$6,
  makeVariables: makeVariables$6,
  variables: variables$6,
  decode: decode$6
};

var include$6 = Apollo.CreateMutation({
      Raw: Raw$6,
      query: query$6,
      variables: variables$6,
      parse: parse$6,
      decode: decode$6
    });

var EditBusinessManager_graphqlMutationAST = include$6.graphqlMutationAST;

var EditBusinessManager_mutate = include$6.mutate;

var EditBusinessManager_mutateStoreError = include$6.mutateStoreError;

var EditBusinessManager_mutateResult = include$6.mutateResult;

var EditBusinessManager_mutateResultStore = include$6.mutateResultStore;

var EditBusinessManager_mutateAsyncData = include$6.mutateAsyncData;

var EditBusinessManager_mutateAsyncResult = include$6.mutateAsyncResult;

var EditBusinessManager_mutateAsycResultApolloError = include$6.mutateAsycResultApolloError;

var EditBusinessManager = {
  Definition: Definition$6,
  graphqlMutationAST: EditBusinessManager_graphqlMutationAST,
  mutate: EditBusinessManager_mutate,
  mutateStoreError: EditBusinessManager_mutateStoreError,
  mutateResult: EditBusinessManager_mutateResult,
  mutateResultStore: EditBusinessManager_mutateResultStore,
  mutateAsyncData: EditBusinessManager_mutateAsyncData,
  mutateAsyncResult: EditBusinessManager_mutateAsyncResult,
  mutateAsycResultApolloError: EditBusinessManager_mutateAsycResultApolloError
};

var Raw$7 = {};

var query$7 = "mutation RemoveBusinessManager($userId: BigInt!)  {\nremoveBusinessManager(input: {userIdToRemove: $userId})  {\nuser  {\n...CommonTypes_Business_Manager   \n}\n\n}\n\n}\n" + CommonTypes_Business_Manager.query;

function parse$7(value) {
  var value$1 = value.removeBusinessManager;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.user;
    tmp = {
      user: !(value$2 == null) ? CommonTypes_Business_Manager.verifyArgsAndParse("CommonTypes_Business_Manager", value$2) : undefined
    };
  }
  return {
          removeBusinessManager: tmp
        };
}

function serialize$7(value) {
  var value$1 = value.removeBusinessManager;
  var removeBusinessManager;
  if (value$1 !== undefined) {
    var value$2 = value$1.user;
    var user = value$2 !== undefined ? CommonTypes_Business_Manager.serialize(value$2) : null;
    removeBusinessManager = {
      user: user
    };
  } else {
    removeBusinessManager = null;
  }
  return {
          removeBusinessManager: removeBusinessManager
        };
}

function serializeVariables$7(inp) {
  return {
          userId: inp.userId
        };
}

function makeVariables$7(userId, param) {
  return {
          userId: userId
        };
}

function variables$7(id) {
  return Json.Encode.object_({
              hd: [
                "userId",
                Curry._1(CommonTypes_Business_Manager.Id.encode, id)
              ],
              tl: /* [] */0
            });
}

function decode$7(param) {
  var match = param.removeBusinessManager;
  if (match !== undefined) {
    return Curry._2(Relude_Option.flatMap, CommonTypes_Business_Manager.tToR, match.user);
  }
  
}

var Definition$7 = {
  Raw: Raw$7,
  query: query$7,
  parse: parse$7,
  serialize: serialize$7,
  serializeVariables: serializeVariables$7,
  makeVariables: makeVariables$7,
  variables: variables$7,
  decode: decode$7
};

var include$7 = Apollo.CreateMutation({
      Raw: Raw$7,
      query: query$7,
      variables: variables$7,
      parse: parse$7,
      decode: decode$7
    });

var RemoveBusinessManager_graphqlMutationAST = include$7.graphqlMutationAST;

var RemoveBusinessManager_mutate = include$7.mutate;

var RemoveBusinessManager_mutateStoreError = include$7.mutateStoreError;

var RemoveBusinessManager_mutateResult = include$7.mutateResult;

var RemoveBusinessManager_mutateResultStore = include$7.mutateResultStore;

var RemoveBusinessManager_mutateAsyncData = include$7.mutateAsyncData;

var RemoveBusinessManager_mutateAsyncResult = include$7.mutateAsyncResult;

var RemoveBusinessManager_mutateAsycResultApolloError = include$7.mutateAsycResultApolloError;

var RemoveBusinessManager = {
  Definition: Definition$7,
  graphqlMutationAST: RemoveBusinessManager_graphqlMutationAST,
  mutate: RemoveBusinessManager_mutate,
  mutateStoreError: RemoveBusinessManager_mutateStoreError,
  mutateResult: RemoveBusinessManager_mutateResult,
  mutateResultStore: RemoveBusinessManager_mutateResultStore,
  mutateAsyncData: RemoveBusinessManager_mutateAsyncData,
  mutateAsyncResult: RemoveBusinessManager_mutateAsyncResult,
  mutateAsycResultApolloError: RemoveBusinessManager_mutateAsycResultApolloError
};

var Raw$8 = {};

var query$8 = "query   {\ncurrentUser  {\nid  \nbusiness  {\nid  \navailableOnsiteManagers  {\nnodes  {\n...CommonTypes_Business_Manager   \n}\n\n}\n\n}\n\n}\n\n}\n" + CommonTypes_Business_Manager.query;

function parse$8(value) {
  var value$1 = value.currentUser;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.business;
    var tmp$1;
    if (value$2 == null) {
      tmp$1 = undefined;
    } else {
      var value$3 = value$2.availableOnsiteManagers;
      var value$4 = value$3.nodes;
      tmp$1 = {
        id: value$2.id,
        availableOnsiteManagers: {
          nodes: value$4.map(function (value) {
                if (!(value == null)) {
                  return CommonTypes_Business_Manager.verifyArgsAndParse("CommonTypes_Business_Manager", value);
                }
                
              })
        }
      };
    }
    tmp = {
      id: value$1.id,
      business: tmp$1
    };
  }
  return {
          currentUser: tmp
        };
}

function serialize$8(value) {
  var value$1 = value.currentUser;
  var currentUser;
  if (value$1 !== undefined) {
    var value$2 = value$1.business;
    var business;
    if (value$2 !== undefined) {
      var value$3 = value$2.availableOnsiteManagers;
      var value$4 = value$3.nodes;
      var nodes = value$4.map(function (value) {
            if (value !== undefined) {
              return CommonTypes_Business_Manager.serialize(value);
            } else {
              return null;
            }
          });
      var availableOnsiteManagers = {
        nodes: nodes
      };
      var value$5 = value$2.id;
      business = {
        id: value$5,
        availableOnsiteManagers: availableOnsiteManagers
      };
    } else {
      business = null;
    }
    var value$6 = value$1.id;
    currentUser = {
      id: value$6,
      business: business
    };
  } else {
    currentUser = null;
  }
  return {
          currentUser: currentUser
        };
}

function serializeVariables$8(param) {
  
}

function makeVariables$8(param) {
  
}

function makeDefaultVariables$2(param) {
  
}

function variables$8(param) {
  return Json.Encode.object_(/* [] */0);
}

function decode$8(param) {
  var match = param.currentUser;
  if (match === undefined) {
    return ;
  }
  var match$1 = match.business;
  if (match$1 !== undefined) {
    return Relude_Option.pure(Curry._1(CommonTypes_Business_Manager.$$Set.fromArray, Relude_Array.mapOption(Curry._1(Relude_Option.flatMap, CommonTypes_Business_Manager.tToR), match$1.availableOnsiteManagers.nodes)));
  }
  
}

var Definition$8 = {
  Raw: Raw$8,
  query: query$8,
  parse: parse$8,
  serialize: serialize$8,
  serializeVariables: serializeVariables$8,
  makeVariables: makeVariables$8,
  makeDefaultVariables: makeDefaultVariables$2,
  variables: variables$8,
  decode: decode$8
};

var include$8 = Apollo.CreateQuery({
      Raw: Raw$8,
      query: query$8,
      variables: variables$8,
      parse: parse$8,
      decode: decode$8
    });

var GetOnsiteManagers_graphqlQueryAST = include$8.graphqlQueryAST;

var GetOnsiteManagers_query = include$8.query;

var GetOnsiteManagers_queryStoreError = include$8.queryStoreError;

var GetOnsiteManagers_queryResult = include$8.queryResult;

var GetOnsiteManagers_queryAsyncData = include$8.queryAsyncData;

var GetOnsiteManagers_queryAsyncDataStoreError = include$8.queryAsyncDataStoreError;

var GetOnsiteManagers_queryAsyncResult = include$8.queryAsyncResult;

var GetOnsiteManagers = {
  Definition: Definition$8,
  graphqlQueryAST: GetOnsiteManagers_graphqlQueryAST,
  query: GetOnsiteManagers_query,
  queryStoreError: GetOnsiteManagers_queryStoreError,
  queryResult: GetOnsiteManagers_queryResult,
  queryAsyncData: GetOnsiteManagers_queryAsyncData,
  queryAsyncDataStoreError: GetOnsiteManagers_queryAsyncDataStoreError,
  queryAsyncResult: GetOnsiteManagers_queryAsyncResult
};

var Raw$9 = {};

var query$9 = "mutation AddBusinessLocation($name: String!, $address: String!)  {\naddBusinessLocation(input: {name: $name, address: $address})  {\nbusinessLocation  {\n...CommonTypes_Business_Location   \n}\n\n}\n\n}\n" + CommonTypes_Business_Location.query;

function parse$9(value) {
  var value$1 = value.addBusinessLocation;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.businessLocation;
    tmp = {
      businessLocation: !(value$2 == null) ? CommonTypes_Business_Location.verifyArgsAndParse("CommonTypes_Business_Location", value$2) : undefined
    };
  }
  return {
          addBusinessLocation: tmp
        };
}

function serialize$9(value) {
  var value$1 = value.addBusinessLocation;
  var addBusinessLocation;
  if (value$1 !== undefined) {
    var value$2 = value$1.businessLocation;
    var businessLocation = value$2 !== undefined ? CommonTypes_Business_Location.serialize(value$2) : null;
    addBusinessLocation = {
      businessLocation: businessLocation
    };
  } else {
    addBusinessLocation = null;
  }
  return {
          addBusinessLocation: addBusinessLocation
        };
}

function serializeVariables$9(inp) {
  return {
          name: inp.name,
          address: inp.address
        };
}

function makeVariables$9(name, address, param) {
  return {
          name: name,
          address: address
        };
}

function variables$9(param) {
  return Json.Encode.object_({
              hd: [
                "name",
                param.name
              ],
              tl: {
                hd: [
                  "address",
                  param.address
                ],
                tl: /* [] */0
              }
            });
}

function decode$9(param) {
  var match = param.addBusinessLocation;
  if (match !== undefined) {
    return Relude_Option.map(CommonTypes_Business_Location.tToR, match.businessLocation);
  }
  
}

var Definition$9 = {
  Raw: Raw$9,
  query: query$9,
  parse: parse$9,
  serialize: serialize$9,
  serializeVariables: serializeVariables$9,
  makeVariables: makeVariables$9,
  variables: variables$9,
  decode: decode$9
};

var include$9 = Apollo.CreateMutation({
      Raw: Raw$9,
      query: query$9,
      variables: variables$9,
      parse: parse$9,
      decode: decode$9
    });

var AddBusinessLocation_graphqlMutationAST = include$9.graphqlMutationAST;

var AddBusinessLocation_mutate = include$9.mutate;

var AddBusinessLocation_mutateStoreError = include$9.mutateStoreError;

var AddBusinessLocation_mutateResult = include$9.mutateResult;

var AddBusinessLocation_mutateResultStore = include$9.mutateResultStore;

var AddBusinessLocation_mutateAsyncData = include$9.mutateAsyncData;

var AddBusinessLocation_mutateAsyncResult = include$9.mutateAsyncResult;

var AddBusinessLocation_mutateAsycResultApolloError = include$9.mutateAsycResultApolloError;

var AddBusinessLocation = {
  Definition: Definition$9,
  graphqlMutationAST: AddBusinessLocation_graphqlMutationAST,
  mutate: AddBusinessLocation_mutate,
  mutateStoreError: AddBusinessLocation_mutateStoreError,
  mutateResult: AddBusinessLocation_mutateResult,
  mutateResultStore: AddBusinessLocation_mutateResultStore,
  mutateAsyncData: AddBusinessLocation_mutateAsyncData,
  mutateAsyncResult: AddBusinessLocation_mutateAsyncResult,
  mutateAsycResultApolloError: AddBusinessLocation_mutateAsycResultApolloError
};

var Raw$10 = {};

var query$10 = "mutation EditBusinessLocation($id: BigInt!, $address: String)  {\neditBusinessLocation(input: {locationToUpdateId: $id, address: $address})  {\nbusinessLocation  {\n...CommonTypes_Business_Location   \n}\n\n}\n\n}\n" + CommonTypes_Business_Location.query;

function parse$10(value) {
  var value$1 = value.editBusinessLocation;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.businessLocation;
    tmp = {
      businessLocation: !(value$2 == null) ? CommonTypes_Business_Location.verifyArgsAndParse("CommonTypes_Business_Location", value$2) : undefined
    };
  }
  return {
          editBusinessLocation: tmp
        };
}

function serialize$10(value) {
  var value$1 = value.editBusinessLocation;
  var editBusinessLocation;
  if (value$1 !== undefined) {
    var value$2 = value$1.businessLocation;
    var businessLocation = value$2 !== undefined ? CommonTypes_Business_Location.serialize(value$2) : null;
    editBusinessLocation = {
      businessLocation: businessLocation
    };
  } else {
    editBusinessLocation = null;
  }
  return {
          editBusinessLocation: editBusinessLocation
        };
}

function serializeVariables$10(inp) {
  var a = inp.address;
  return {
          id: inp.id,
          address: a !== undefined ? a : undefined
        };
}

function makeVariables$10(id, address, param) {
  return {
          id: id,
          address: address
        };
}

function variables$10(param) {
  return Json.Encode.object_({
              hd: [
                "id",
                Curry._1(CommonTypes_Business_Location.Id.encode, param.id)
              ],
              tl: {
                hd: [
                  "address",
                  param.address
                ],
                tl: /* [] */0
              }
            });
}

function decode$10(param) {
  var match = param.editBusinessLocation;
  if (match !== undefined) {
    return Relude_Option.map(CommonTypes_Business_Location.tToR, match.businessLocation);
  }
  
}

var Definition$10 = {
  Raw: Raw$10,
  query: query$10,
  parse: parse$10,
  serialize: serialize$10,
  serializeVariables: serializeVariables$10,
  makeVariables: makeVariables$10,
  variables: variables$10,
  decode: decode$10
};

var include$10 = Apollo.CreateMutation({
      Raw: Raw$10,
      query: query$10,
      variables: variables$10,
      parse: parse$10,
      decode: decode$10
    });

var EditBusinessLocation_graphqlMutationAST = include$10.graphqlMutationAST;

var EditBusinessLocation_mutate = include$10.mutate;

var EditBusinessLocation_mutateStoreError = include$10.mutateStoreError;

var EditBusinessLocation_mutateResult = include$10.mutateResult;

var EditBusinessLocation_mutateResultStore = include$10.mutateResultStore;

var EditBusinessLocation_mutateAsyncData = include$10.mutateAsyncData;

var EditBusinessLocation_mutateAsyncResult = include$10.mutateAsyncResult;

var EditBusinessLocation_mutateAsycResultApolloError = include$10.mutateAsycResultApolloError;

var EditBusinessLocation = {
  Definition: Definition$10,
  graphqlMutationAST: EditBusinessLocation_graphqlMutationAST,
  mutate: EditBusinessLocation_mutate,
  mutateStoreError: EditBusinessLocation_mutateStoreError,
  mutateResult: EditBusinessLocation_mutateResult,
  mutateResultStore: EditBusinessLocation_mutateResultStore,
  mutateAsyncData: EditBusinessLocation_mutateAsyncData,
  mutateAsyncResult: EditBusinessLocation_mutateAsyncResult,
  mutateAsycResultApolloError: EditBusinessLocation_mutateAsycResultApolloError
};

var Raw$11 = {};

var query$11 = "mutation RemoveBusinessLocation($id: BigInt!)  {\nremoveBusinessLocation(input: {locationIdToRemove: $id})  {\nbusinessLocation  {\n...CommonTypes_Business_Location   \n}\n\n}\n\n}\n" + CommonTypes_Business_Location.query;

function parse$11(value) {
  var value$1 = value.removeBusinessLocation;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.businessLocation;
    tmp = {
      businessLocation: !(value$2 == null) ? CommonTypes_Business_Location.verifyArgsAndParse("CommonTypes_Business_Location", value$2) : undefined
    };
  }
  return {
          removeBusinessLocation: tmp
        };
}

function serialize$11(value) {
  var value$1 = value.removeBusinessLocation;
  var removeBusinessLocation;
  if (value$1 !== undefined) {
    var value$2 = value$1.businessLocation;
    var businessLocation = value$2 !== undefined ? CommonTypes_Business_Location.serialize(value$2) : null;
    removeBusinessLocation = {
      businessLocation: businessLocation
    };
  } else {
    removeBusinessLocation = null;
  }
  return {
          removeBusinessLocation: removeBusinessLocation
        };
}

function serializeVariables$11(inp) {
  return {
          id: inp.id
        };
}

function makeVariables$11(id, param) {
  return {
          id: id
        };
}

function variables$11(id) {
  return Json.Encode.object_({
              hd: [
                "id",
                Curry._1(CommonTypes_Business_Location.Id.encode, id)
              ],
              tl: /* [] */0
            });
}

function decode$11(param) {
  var match = param.removeBusinessLocation;
  if (match !== undefined) {
    return Relude_Option.map(CommonTypes_Business_Location.tToR, match.businessLocation);
  }
  
}

var Definition$11 = {
  Raw: Raw$11,
  query: query$11,
  parse: parse$11,
  serialize: serialize$11,
  serializeVariables: serializeVariables$11,
  makeVariables: makeVariables$11,
  variables: variables$11,
  decode: decode$11
};

var include$11 = Apollo.CreateMutation({
      Raw: Raw$11,
      query: query$11,
      variables: variables$11,
      parse: parse$11,
      decode: decode$11
    });

var RemoveBusinessLocation_graphqlMutationAST = include$11.graphqlMutationAST;

var RemoveBusinessLocation_mutate = include$11.mutate;

var RemoveBusinessLocation_mutateStoreError = include$11.mutateStoreError;

var RemoveBusinessLocation_mutateResult = include$11.mutateResult;

var RemoveBusinessLocation_mutateResultStore = include$11.mutateResultStore;

var RemoveBusinessLocation_mutateAsyncData = include$11.mutateAsyncData;

var RemoveBusinessLocation_mutateAsyncResult = include$11.mutateAsyncResult;

var RemoveBusinessLocation_mutateAsycResultApolloError = include$11.mutateAsycResultApolloError;

var RemoveBusinessLocation = {
  Definition: Definition$11,
  graphqlMutationAST: RemoveBusinessLocation_graphqlMutationAST,
  mutate: RemoveBusinessLocation_mutate,
  mutateStoreError: RemoveBusinessLocation_mutateStoreError,
  mutateResult: RemoveBusinessLocation_mutateResult,
  mutateResultStore: RemoveBusinessLocation_mutateResultStore,
  mutateAsyncData: RemoveBusinessLocation_mutateAsyncData,
  mutateAsyncResult: RemoveBusinessLocation_mutateAsyncResult,
  mutateAsycResultApolloError: RemoveBusinessLocation_mutateAsycResultApolloError
};

exports.GetBusinessAdmins = GetBusinessAdmins;
exports.AddBusinessAdmin = AddBusinessAdmin;
exports.EditBusinessAdmin = EditBusinessAdmin;
exports.RemoveBusinessAdmin = RemoveBusinessAdmin;
exports.GetBusinessManagers = GetBusinessManagers;
exports.AddBusinessManager = AddBusinessManager;
exports.EditBusinessManager = EditBusinessManager;
exports.RemoveBusinessManager = RemoveBusinessManager;
exports.GetOnsiteManagers = GetOnsiteManagers;
exports.AddBusinessLocation = AddBusinessLocation;
exports.EditBusinessLocation = EditBusinessLocation;
exports.RemoveBusinessLocation = RemoveBusinessLocation;
/* include Not a pure module */
